const finite = value => typeof value === 'number' && Number.isFinite(value);

export const buildQualityMatrix = (agents = [], requestedMetric = 'auto') => {
  const eligible = agents.filter(agent => finite(agent.noticesIssued) && agent.noticesIssued > 0
    && finite(agent.completenessRate) && agent.completenessRate >= 0 && agent.completenessRate <= 100);
  const hasRate = agent => finite(agent.noticesPerHour) && agent.noticesPerHour >= 0
    && finite(agent.hoursWorked) && agent.hoursWorked > 0;
  const missingHours = eligible.filter(agent => !hasRate(agent)).length;
  const metric = requestedMetric === 'auto'
    ? (eligible.length && !missingHours ? 'noticesPerHour' : 'noticesIssued')
    : requestedMetric;
  const plotted = metric === 'noticesPerHour' ? eligible.filter(hasRate) : eligible;
  return {
    metric, missingHours,
    axisLabel: metric === 'noticesPerHour' ? 'Avis par heure estimée' : 'Avis émis sur la période',
    points: plotted.map(agent => ({ x: agent[metric], y: agent.completenessRate, agent })),
  };
};
